import {
  FormControl,
  FormGroup,
  requiredValidator,
} from "@quantumart/mobx-form-validation-kit";
import { patternValidator } from "../utils/validators";
import { FormGroupWrapped } from "../types/formControl";
import { AppealStatusType, IAppeal, IAppealEditForm } from "../types/appeals";
import { makeObservable, observable } from "mobx";
import i18n from "../i18n";

type AppealFormType = FormGroupWrapped<Pick<IAppeal, "tin" | "status">>;

export class AppealCard {
  rawAppeal: IAppeal;
  form: AppealFormType;
  constructor(form: IAppeal) {
    makeObservable(this, {
      form: observable,
      rawAppeal: observable,
    });
    this.rawAppeal = form;
    this.form = new FormGroup({
      tin: new FormControl(form?.tin || "", {
        validators: [
          patternValidator("[PM]\\d{6}[A-Z]\\d{3}", () =>
            i18n.t("TIN_FORMAT_ERROR")
          ),
        ],
      }),
      status: new FormControl<AppealStatusType>(form?.status || "NEW", {
        validators: [requiredValidator("Неверный статус")],
      }),
    });
  }

  getForm(): IAppealEditForm {
    return {
      id: this.rawAppeal.id,
      address: this.rawAppeal.address,
      tin: this.form.controls.tin.value,
      status: this.form.controls.status.value,
    };
  }
}
